import { CustomFontAwesomeIconProps } from './types'

import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Cross = (props: CustomFontAwesomeIconProps) => <FontAwesomeIcon {...props} icon={faXmark} />

export default Cross
